import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Provider } from '@angular/core';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

export class NavigatorInterceptor implements HttpInterceptor {
  private readonly NAVIGATOR_DEVICE_ID_HTTP_HEADER = 'Elio-Device-Id';
  private readonly NAVIGATOR_USER_AGENT_HTTP_HEADER = 'Elio-Ip-User-Agent';

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const newRequest = request.clone({
      setHeaders: {
        [this.NAVIGATOR_DEVICE_ID_HTTP_HEADER]: this.getDeviceId(),
        [this.NAVIGATOR_USER_AGENT_HTTP_HEADER]: navigator.userAgent,
      },
    });
    return next.handle(newRequest);
  }

  private getDeviceId(): string {
    let deviceId = localStorage.getItem('deviceId');
    if (!deviceId) {
      deviceId = uuidv4();
      localStorage.setItem('deviceId', deviceId);
    }
    return deviceId;
  }
}

export const NAVIGATOR_INTERCEPTOR_PROVIDER: Provider = {
  provide: HTTP_INTERCEPTORS,
  useClass: NavigatorInterceptor,
  multi: true,
};
